var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('fieldset',[_c('div',{staticClass:"form-wrap"},[_c('input',{attrs:{"type":"file"},on:{"change":_vm.selectFile}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }